/** @jsx jsx */

import { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import { renderToString } from 'react-dom/server';

export const Bubbles = ({ color = '#66ccff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 415 242"
    preserveAspectRatio="xMidYMid slice"
    fill="none"
  >
    <g id="Bubbles" clipPath="url(#clip0_872_1005)">
      <path
        id="Vector"
        d="M0.000823975 242L414.826 242V0L0.000823975 0V242Z"
        fill={color}
        // "#4EA3F7"
      />
      <g id="Group 8395">
        <path
          id="Vector_2"
          opacity="0.07"
          d="M340.351 159.327C330.83 170.33 323.642 183.445 319.606 197.885C319.448 198.484 319.291 199.02 319.133 199.619C318.345 198.799 317.525 197.979 316.705 197.223C303.59 184.895 286.029 177.329 266.671 177.329C263.676 177.329 260.713 177.581 257.812 177.928C224.614 181.964 198.288 208.289 194 241.676L414.948 241.676L414.948 125C385.173 125.084 358.516 138.363 340.35 159.326L340.351 159.327Z"
          fill="black"
        >
          <animate
            attributeName="d"
            values="M340.351 159.327C330.83 170.33 323.642 183.445 319.606 197.885C319.448 198.484 319.291 199.02 319.133 199.619C318.345 198.799 317.525 197.979 316.705 197.223C303.59 184.895 286.029 177.329 266.671 177.329C263.676 177.329 260.713 177.581 257.812 177.928C224.614 181.964 198.288 208.289 194 241.676L414.948 241.676L414.948 125C385.173 125.084 358.516 138.363 340.35 159.326L340.351 159.327Z;M337.347 165.774C327.436 175.959 319.953 188.099 315.752 201.465C315.587 202.02 315.424 202.516 315.26 203.07C314.439 202.311 313.586 201.552 312.732 200.853C299.08 189.441 280.799 182.438 260.648 182.438C257.531 182.438 254.446 182.671 251.426 182.992C216.868 186.728 181.964 211.096 177.5 242L415 242L415 134C384.005 134.078 356.256 146.369 337.346 165.774L337.347 165.774Z;M340.351 159.327C330.83 170.33 323.642 183.445 319.606 197.885C319.448 198.484 319.291 199.02 319.133 199.619C318.345 198.799 317.525 197.979 316.705 197.223C303.59 184.895 286.029 177.329 266.671 177.329C263.676 177.329 260.713 177.581 257.812 177.928C224.614 181.964 198.288 208.289 194 241.676L414.948 241.676L414.948 125C385.173 125.084 358.516 138.363 340.35 159.326L340.351 159.327Z"
            begin="0s"
            dur="8s"
            repeatCount="indefinite"
            fill="freeze"
            calcMode="linear"
            keyTimes="0;0.5;1"
          />
        </path>
        <g id="Group" opacity="0.07">
          <path
            id="Vector_3"
            d="M0 59.755C34.249 59.659 64.913 44.384 85.809 20.27C91.18 14.063 95.901 7.269 99.87 0L0 0L0 59.755Z"
            fill="white"
          >
            <animate
              attributeName="d"
              values="M0 59.755C34.249 59.659 64.913 44.384 85.809 20.27C91.18 14.063 95.901 7.269 99.87 0L0 0L0 59.755Z;M0 68C35.5 72 67.8214 58.4413 90 31C95.7007 23.9366 101.5 14.5 106 0L0 0L0 68Z;M0 59.755C34.249 59.659 64.913 44.384 85.809 20.27C91.18 14.063 95.901 7.269 99.87 0L0 0L0 59.755Z"
              begin="0s"
              dur="8s"
              repeatCount="indefinite"
              fill="freeze"
              calcMode="linear"
              keyTimes="0;0.5;1"
            />
          </path>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_872_1005">
        <rect width="415" height="242" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const bubblesSVGToString = color =>
  renderToString(<Bubbles color={color} />);
